import React from 'react'
import WidgetClass from 'widgets/WidgetClass'
import Section from 'layouts/page/Section'
import * as Filters from 'support/filters'
import PageBreadcrumbs from 'widgets/navigation/PageBreadcrumbs'
import NotificationWidget from 'widgets/notifications/NotificationWidget'
import WhenDeviceNotAuthorized from 'support/conditionals/WhenDeviceNotAuthorized'
import {Env} from "@morningtrain/helpers";

export default class AdminTopNavigation extends WidgetClass {
  get menuItems () {
    const hasFirm = Env.get('globals.has_firm');
    const is_stocktake = Env.get('page.component') === "app.Inventory.Stocktake";
    return (
      <div className={`flex items-center input-white ${is_stocktake ? `fixed right-6 pt-1` : `justify-between`}`}>
        <div className={`flex space-x-5 ${is_stocktake ? 'mr-3' : ''}`}>
          {this.props.withGlobalDepartmentFilter !== false
            ? (
                <WhenDeviceNotAuthorized>
                  {hasFirm ?
                    <Filters.GlobalFirmFilter wrapperClassName='input-white' withoutAllDepartments={this.props.withoutAllDepartments} />
                    : false
                  }
                  <Filters.GlobalDepartmentFilter wrapperClassName='input-white' withoutAllDepartments={this.props.withoutAllDepartments} />
                </WhenDeviceNotAuthorized>
              )
            : null}
          {is_stocktake ? null : <PageBreadcrumbs />}
        </div>
        <WhenDeviceNotAuthorized>
          <NotificationWidget />
        </WhenDeviceNotAuthorized>
      </div>
    )
  }

  renderWidget () {
    return (
      <Section>
        <div className='top-navigation ghost' />
        <div className='top-navigation'>
          <div className='top-navigation__item-wrap'>
            {this.menuItems}
          </div>
        </div>
      </Section>
    )
  }
}
